












































import { Component, Vue, Prop } from 'vue-property-decorator';

import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listPayService: any;
    private isCheckAll = false;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    private async viewDetail(payservice: any) {
        const routeData = this.$router.resolve({ name: 'payservice-detail', params: { id: payservice.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }

    private async onCheckAllOrder() {
        this.$emit(this.eventEmit.eventCheckALl, this.isCheckAll);
    }
}
